import React, { Component } from 'react'
import { isMobile } from 'react-device-detect'

import Select from 'react-select'
import i18n from '../../i18n'
class Filter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hideFilters: isMobile,
      dateFilter: [],
    }
  }
  resize = () => {
    if (window.innerWidth < 992) {
      this.setState({ hideFilters: true })
    } else {
      this.setState({ hideFilters: false })
    }
  }

  componentDidMount() {
    if (!isMobile) {
      window.addEventListener('resize', this.resize)
    }
  }

  componentWillUnmount() {
    if (!isMobile) {
      window.removeEventListener('resize', this.resize)
    }
  }

  openModal = () => {
    this.setState({ hideFilters: false })
    this.setState({ dateFilter: [] })
    if (!this.props.hasFiltersApplied) {
      /** Probably this is not needed anymore as we use react state now. **/
      this.clearFields()
    }
    document.body.classList.add('calendar-filters-modal-overlay')
  }

  closeModal = () => {
    this.setState({ hideFilters: true })
    this.setState({ dateFilter: [] })
    document.body.classList.remove('calendar-filters-modal-overlay')
  }

  clearFields = () => {
    document.getElementById('championship').value = ''
    this.setState({ dateFilter: [] })
    this.props.onClearFilters()
  }

  render() {
    const { i18n } = this.props

    let monthFilterLinks = this.props.months.map((month, index) => (
      <a
        key={index}
        className="month"
        data-month={month}
        onClick={this.props.scrollToRef}
      >
        {month}
      </a>
    ))

    let yearsFilterLinks = this.props.years.map((year, index) => (
      <a
        key={index}
        className="month"
        data-month={year}
        onClick={this.props.scrollToRef}
      >
        {year}
      </a>
    ))

    let displayableContinents = this.props.availableRegions
    let continents = displayableContinents.map((value, _index) => ({
      value: value,
      label: value,
    }))

    let displayableChampTypes = this.props.availableChampTypes
    let championshipTypes = displayableChampTypes.map((value, _index) => ({
      value: value.name,
      label: value.name,
    }))

    let filterOptions = this.props.months.concat(this.props.years)
    let monthYearsFilterOptions = filterOptions.map((value, index) => ({
      value: value,
      label: value,
    }))

    let castChampTypes = null
    let castChampRegions = null
    let castChampDates = null

    if (this.props.champTypes !== undefined) {
      castChampTypes = this.props.champTypes.map((value, index) => ({
        value: value,
        label: value,
      }))
    }
    if (this.props.champRegions !== undefined) {
      castChampRegions = this.props.champRegions.map((value, index) => ({
        value: value,
        label: value,
      }))
    }
    if (this.state.dateFilter !== undefined) {
      castChampDates = this.state.dateFilter.map((value, index) => ({
        value: value,
        label: value,
      }))
    }

    let tinyScreens = window.innerHeight < 750

    //let championshipPlaceholder = tinyScreens ? i18n.t('calendar.filters.keywordTitle') : i18n.t('calendar.filters.keywordPlaceholder')
    let championshipTypePlaceholder = tinyScreens
      ? i18n.t('calendar.filters.championshipTypeTitle')
      : i18n.t('calendar.filters.championshipTypePlaceholder')
    let championshipRegionPlaceholder = tinyScreens
      ? i18n.t('calendar.filters.regionTitle')
      : i18n.t('calendar.filters.regionPlaceholder')
    let championshipDatePlaceholder = tinyScreens
      ? i18n.t('calendar.filters.dateTitle')
      : i18n.t('calendar.filters.datePlaceholder')

    /** Guess that it would be better to customize the select in a css file **/
    /** but using the function seemed easier for now; TODO: Extract to scss **/
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
      }),
      menu: (provided, state) => ({
        ...provided,
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: state.isFocused ? 'var(--secondary)' : 'var(--primary)',
      }),
      indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none',
      }),
      indicatorContainer: (provided, state) => ({
        ...provided,
      }),
      control: (provided, state) => ({
        ...provided,
        '&:hover': {
          borderColor: 'var(--secondary)',
        },
        borderColor: state.isFocused ? 'var(--secondary)' : 'var(--primary)',
        boxShadow: state.isFocused ? '0 0 0' : '0 0 0',
        // IBJJF COLOR: boxShadow: state.isFocused ? "0 0 0 0.2rem rgb(0 69 129 / 25%)" : "0 0 0"
        // CBJJ COLOR:  boxShadow: state.isFocused ? "0 0 0 0.2rem rgb(21 78 60 / 25%)" : "0 0 0"
      }),
    }

    return (
      <React.Fragment>
        <span
          onClick={this.openModal}
          className="expand-filters-button d-lg-none d-xl-none"
        >
          <span className="filters-icon">
            <i className="fa fa-sliders" />
          </span>
          <span className="filters-button">
            {i18n.t('calendar.filters.openFilters')}
          </span>
        </span>

        <div
          className="infosite-filters"
          id="filter-form"
          hidden={this.state.hideFilters}
        >
          <div className="col-12 filters-body">
            <form className="container">
              <div className="form-row">
                <section className="filters-modal-header d-lg-none d-xl-none">
                  <p> {i18n.t('calendar.filters.selectFilters')} </p>
                  <a className="close-filters-action" onClick={this.closeModal}>
                    <i className="fa fa-times fa-2x" />
                  </a>
                </section>

                <div
                  className={`form-group has-feedback ${
                    this.props.showRegion ? 'col-md-4' : 'col-md-6'
                  }`}
                >
                  <label htmlFor="championship">
                    {i18n.t('calendar.filters.keywordTitle')}
                  </label>
                  <span className="input-group">
                    <input
                      type="text"
                      //** overriding default bootstrap style. Remove form control; **/
                      className="form-control search-box"
                      id="championship"
                      placeholder={i18n.t(
                        'calendar.filters.keywordPlaceholder'
                      )}
                      onChange={this.props.onChange}
                      value={this.props.champNames}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text border border-primary bg-primary text-white">
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                  </span>
                </div>

                <div
                  className={`form-group ${
                    this.props.showRegion ? 'col-md-4' : 'col-md-6'
                  }`}
                >
                  <label htmlFor="c-type">
                    {i18n.t('calendar.filters.championshipTypeTitle')}
                  </label>
                  <Select
                    styles={customStyles}
                    name={'championshipType'}
                    id="championshipTypeField"
                    isMulti={true}
                    isSearchable={true}
                    placeholder={championshipTypePlaceholder}
                    options={championshipTypes}
                    onChange={this.props.onChange}
                    value={castChampTypes}
                  />
                </div>

                {this.props.showRegion ? (
                  <div className="form-group col-md-4">
                    <label htmlFor="region">
                      {i18n.t('calendar.filters.regionTitle')}
                    </label>
                    <Select
                      styles={customStyles}
                      name={'region'}
                      id="regionField"
                      isMulti={true}
                      isSearchable={true}
                      placeholder={championshipRegionPlaceholder}
                      options={continents}
                      onChange={this.props.onChange}
                      value={castChampRegions}
                    />
                  </div>
                ) : null}

                <div className="form-group col-md-4">
                  <div className="d-lg-none d-xl-none">
                    <label htmlFor="c-type">
                      {i18n.t('calendar.filters.dateTitle')}
                    </label>
                    <Select
                      styles={customStyles}
                      name={'date'}
                      id="dateField"
                      isMulti={false}
                      isSearchable={false}
                      placeholder={championshipDatePlaceholder}
                      options={monthYearsFilterOptions}
                      onChange={(event) => {
                        this.props.scrollToRef(event)
                        this.setState({ dateFilter: [event.value] })
                      }}
                      value={castChampDates}
                    />
                  </div>
                </div>

                <section className="filters-modal-footer d-lg-none d-xl-none">
                  <p className="filters-active-values"></p>
                  <a
                    className="clear-filters-action"
                    onClick={this.clearFields}
                  >
                    {i18n.t('calendar.filters.clearAllFilters')}
                  </a>
                </section>
              </div>
            </form>
          </div>

          <div className="col-12 action-buttons filter-results-actions d-lg-none d-xl-none">
            <span className="filter-results-actions">
              <a className="search-results-action" onClick={this.closeModal}>
                {i18n.t('calendar.filters.showResults', {
                  count: this.props.resultsFound,
                })}
              </a>
            </span>
          </div>
        </div>

        <div className="row d-none d-lg-flex d-xl-flex">
          <div className="col-12">
            <div className="container months-filter">
              {monthFilterLinks}
              {yearsFilterLinks}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Filter
